import React from 'react';
import { connect } from 'react-redux'
import * as commonActionCreator from '../../../redux/actions/data-action';
import { TaskType, SubTaskType, getTasks } from '../../../redux/actions/data-action';
import createTask from '../tasks/tasks';
import { TaskNoteDialog } from '../common/task-controls';
import { RatingScaleTask } from '../tasks/tasks-rating-scale';

class PracticeRatingScaleTask extends RatingScaleTask {
    constructor(props) {
        super(props);

        this.state = { isDisplayNote: false }
        this.handleNoteClose = this.handleNoteClose.bind(this);
    }

    componentDidMount() {
        this.setState({ isDisplayNote: true });
    }

    handleNoteClose() {
        this.setState({ isDisplayNote: false });
    }

    render() {
        return (
            <React.Fragment>
                <TaskNoteDialog onClose={this.handleNoteClose} visible={this.state.isDisplayNote}>
                    You must fully complete a question by filling all of the empty boxes to receive credit for the question.
                </TaskNoteDialog>
                {(super.render())}
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state, ownState) => ({
    tasks : getTasks(state.data.tasks, TaskType.RATING, SubTaskType.PRACTICE),
    taskType: TaskType.RATING,
    subTaskType: SubTaskType.PRACTICE,
    footerLabel: "PRACTICE",
    taskContentClassName: 'task-content-practice',
    versionID: state.data.versionID
})

export default connect(mapStateToProps, Object.assign({}, commonActionCreator))(createTask(PracticeRatingScaleTask))